import { fork, all } from 'redux-saga/effects';
import { contentSaga, navigationLinkContentSaga, getGuestContentSaga, findAKFCContentSaga, getDynMenuAlert, } from '../../middleware/contentSagas';
import { syncContentSaga, fetchContentEntrySaga } from '../../middleware/syncContentfulSagas';
import { OfferAndDealsSaga, reOrderSaga, deleteAddressSaga, addNewAddressSaga } from '../../middleware/orderServSaga';
import marketConfigSaga from '../../middleware/marketConfigSagas';
import moreSaga from '../../middleware/moreSaga';
import orderLookupSaga from '../../middleware/orderLookupSaga';
import helpSaga from '../../middleware/helpSaga';
import contentfulSaga from '../../middleware/ContentfulSaga';
import { brazeSubscriptionsSaga } from '../../middleware/BrazeSagas';
import { brazeSubscriptionsSagaV2 } from '../../middleware/BrazeSagasV2';
import { addItemToCartSaga, createBasketsAction, deleteBasketsSaga, basketDetailsSaga, updateItemQuantitySaga, removeLineItemSaga, removeMultipleLineItemSaga, removeAllItemSaga, recommendationRulesSaga, getApplicableCouponsActionSaga, applyCouponActionSaga, removeCouponActionSaga, removeAllCouponActionSaga, validateBasketSaga, getNonLocalisedCouponsSaga, getLoggedinNonLocalizedCouponSaga, updateLineItemSaga, updateCustomerIDForBasketSaga, bulkupdateItemQuantitySaga, updateCartWithStoreAndDispositionSaga, } from '../../middleware/cartSaga';
import { placesAutocompleteSaga, placesGeolocationSaga, getAddressSaga, clearList, } from '../../middleware/placesAutocompleteSaga';
import NearbyStoresSaga, { DistanceGoogleApiSaga, StoreStatusApiSaga, availableTimeSlotsApiSaga, getStoreStatusForTimeSaga, getOrderReadyDateTimeUpdate, setStoresFavouriteSaga, setStoresUnFavouriteSaga, storeAvailableAllTimeSlotsApiSaga, getStoreDetailsSaga, getRestaurantDetailsSaga, favoriteStoreStatusApiSaga, getStoreDetailsContentFullData, getContactUsRestaurantDetailsSaga, getDeliveryLocationLocalizationData, } from '../../middleware/storesSaga';
import { deleteCustomerAccountSaga, updateCustomerInfoSaga, marketingPreferenceSaga, } from '../../middleware/customerInformationSaga';
import { menuSaga, itemDetailsSaga, recommendedProductSaga, addItemToFavouriteSaga, addItemUnFavouriteSaga, } from '../../middleware/menuSaga';
import specialEventSaga from '../../middleware/specialEventSaga';
import { i18nGetContentSaga } from '../../middleware/i18nSaga';
import { getNetbankingConfigurationsSaga, payUsingNetbankingSaga, payUsingPaytmSaga, payUsingPhonePeSaga, checkPhonePeStatusSaga, checkPaytmStatusSaga, getAllowedWalletsListSaga, payUsingGooglePaySaga, deleteSavedCardSaga, globalPaymentsGenerateTokenSaga, globalpaymentsInitiatePaymentSaga, globalpaymentsAddressValidateSaga, paymentForAddHopeSaga, paymentForGiftCardSaga, gpSavecardSaga, gpIsStore3dsEnabledSaga, gpCardVerifySaga, } from '../../middleware/paymentsSaga';
import { createOrderSaga, getOrdersSaga, getPastOrderSaga, updateCustomerIDforOrderSaga, validateOrderSaga, } from '../../middleware/orderSaga';
import { getTendersContentSaga } from '../../middleware/paymentsContentSaga';
import { giftCardStatus, paymentUsingGiftCardSaga } from '../../middleware/paymentGiftCardSaga';
import { checkBalanceSaga, getCardDetailsSaga } from '../../middleware/GiftCheckBalanceSaga';
import { appRatingsSaga } from '../../middleware/appRatingsSaga';
import { appConfigsSaga, sitemapDataSaga } from '../../middleware/appConfigsSaga';
import { brandPageSaga } from '../../middleware/brandPageSaga';
import privacyPolicySaga from '../../middleware/privacyPolicySagas';
import ourAdSaga from '../../middleware/ourAdSaga';
import GiftCardSaga from '../../middleware/giftCardSaga';
import { submitFeedbackSaga } from '../../middleware/feedbackSaga';
import { orderAcceptedSaga, fetchCashTranscationIdSaga, cancelPostOrderSaga, checkInRequestSaga, addHopePaymentAcceptedSaga, giftCardPostPurchaseSaga } from '../../middleware/postOrderSaga';
import deliveryAggregatorSaga from '../../middleware/DeliveryAggregatorSaga';
import faqSaga from '../../middleware/FaqSaga';
import contactUsSaga from '../../middleware/contactUsSaga';
import termsOfUseSaga from '../../middleware/termsOfUseSagas';
import purchaseGiftcardSaga from '../../middleware/giftCardPurchaseSaga';
import { tenantConfigUpdateSaga } from '../../middleware/tenantSaga';
import { getOrderHistorySaga, setFavOrderSaga, deleteFavOrderCallSaga, getActiveOrderHistorySaga, } from '../../middleware/OrderHistorySaga';
import { reorderStoreStatusApiSaga, reorderMenuSaga, reOrderAcceptedSaga } from '../../middleware/ReorderSaga';
import { googleSpotInitiatePaymentSaga, googleSpotValidateResponseSaga, googleSpotCheckTransactionStatusSaga, } from '../../middleware/paymentGoogleSpotSaga';
import { payforPaytmMiniApp, checkPaytmMiniappStatusSaga, payforPhonepeSwitchApp, paymentStatusForPhonepeSwitch, } from '../../middleware/microAppPaymentSagas';
import { webAppVersionSaga } from '../../middleware/appVersionSaga';
import plpDisclaimerContentSaga from '../../middleware/plpDisclaimerSagas';
import { generateClientTokenSaga, transactionSaleSaga, transactionSubmitSaga, transactionVoidSaga, } from '../../middleware/BraintreePaymnetSaga';
import { fetchTokensSaga, refreshTokenSaga, logoutUserSaga, fetchGoogleSpotTokensSaga, fetchCustomerDetailsSaga, } from '../../middleware/AuthSaga';
import protectedDisclosureSaga from '../../middleware/protectedDisclosureSaga';
import nutritionAllergenDisclaimerSaga from '../../middleware/nutritionAllergenDisclaimerSaga';
import naSingleItemSaga from '../../middleware/naSingleItemSaga';
const rootSaga = function* root() {
    yield all([
        fork(updateCustomerIDForBasketSaga),
        fork(contentSaga),
        fork(navigationLinkContentSaga),
        fork(OfferAndDealsSaga),
        fork(reOrderSaga),
        fork(marketConfigSaga),
        fork(moreSaga),
        fork(placesAutocompleteSaga),
        fork(placesGeolocationSaga),
        fork(getAddressSaga),
        fork(clearList),
        fork(NearbyStoresSaga),
        fork(DistanceGoogleApiSaga),
        fork(StoreStatusApiSaga),
        fork(favoriteStoreStatusApiSaga),
        fork(orderLookupSaga),
        fork(fetchCustomerDetailsSaga),
        fork(updateCustomerInfoSaga),
        fork(deleteCustomerAccountSaga),
        fork(availableTimeSlotsApiSaga),
        fork(createBasketsAction),
        fork(menuSaga),
        fork(specialEventSaga),
        fork(helpSaga),
        fork(contentfulSaga),
        fork(brazeSubscriptionsSaga),
        fork(brazeSubscriptionsSagaV2),
        fork(itemDetailsSaga),
        fork(setStoresFavouriteSaga),
        fork(setStoresUnFavouriteSaga),
        fork(recommendedProductSaga),
        fork(getStoreStatusForTimeSaga),
        fork(getOrderReadyDateTimeUpdate),
        fork(addItemToCartSaga),
        fork(deleteBasketsSaga),
        fork(basketDetailsSaga),
        fork(updateItemQuantitySaga),
        fork(addItemToFavouriteSaga),
        fork(addItemUnFavouriteSaga),
        fork(removeLineItemSaga),
        fork(removeMultipleLineItemSaga),
        fork(removeAllItemSaga),
        fork(getApplicableCouponsActionSaga),
        fork(applyCouponActionSaga),
        fork(removeCouponActionSaga),
        fork(removeAllCouponActionSaga),
        fork(recommendationRulesSaga),
        fork(i18nGetContentSaga),
        fork(validateBasketSaga),
        fork(getNonLocalisedCouponsSaga),
        fork(getLoggedinNonLocalizedCouponSaga),
        fork(getNetbankingConfigurationsSaga),
        fork(createOrderSaga),
        fork(getTendersContentSaga),
        fork(paymentUsingGiftCardSaga),
        fork(giftCardStatus),
        fork(checkBalanceSaga),
        fork(getCardDetailsSaga),
        fork(payUsingNetbankingSaga),
        fork(payUsingGooglePaySaga),
        fork(getOrdersSaga),
        fork(privacyPolicySaga),
        fork(ourAdSaga),
        fork(GiftCardSaga),
        fork(syncContentSaga),
        fork(storeAvailableAllTimeSlotsApiSaga),
        fork(orderAcceptedSaga),
        fork(cancelPostOrderSaga),
        fork(checkInRequestSaga),
        fork(addHopePaymentAcceptedSaga),
        fork(giftCardPostPurchaseSaga),
        fork(fetchCashTranscationIdSaga),
        fork(fetchContentEntrySaga),
        fork(appRatingsSaga),
        fork(appConfigsSaga),
        fork(sitemapDataSaga),
        fork(tenantConfigUpdateSaga),
        fork(brandPageSaga),
        fork(updateLineItemSaga),
        fork(submitFeedbackSaga),
        fork(deliveryAggregatorSaga),
        fork(faqSaga),
        fork(payUsingPaytmSaga),
        fork(contactUsSaga),
        fork(termsOfUseSaga),
        fork(getPastOrderSaga),
        fork(purchaseGiftcardSaga),
        fork(getOrderHistorySaga),
        fork(getActiveOrderHistorySaga),
        fork(setFavOrderSaga),
        fork(payUsingPhonePeSaga),
        fork(checkPhonePeStatusSaga),
        fork(checkPaytmStatusSaga),
        fork(deleteFavOrderCallSaga),
        fork(deleteAddressSaga),
        fork(addNewAddressSaga),
        fork(deleteSavedCardSaga),
        fork(paymentForAddHopeSaga),
        fork(paymentForGiftCardSaga),
        fork(getAllowedWalletsListSaga),
        fork(googleSpotInitiatePaymentSaga),
        fork(googleSpotValidateResponseSaga),
        fork(googleSpotCheckTransactionStatusSaga),
        fork(payforPaytmMiniApp),
        fork(checkPaytmMiniappStatusSaga),
        fork(reorderStoreStatusApiSaga),
        fork(reorderMenuSaga),
        fork(marketingPreferenceSaga),
        fork(payforPhonepeSwitchApp),
        fork(paymentStatusForPhonepeSwitch),
        fork(reOrderAcceptedSaga),
        fork(getStoreDetailsSaga),
        fork(getRestaurantDetailsSaga),
        fork(webAppVersionSaga),
        fork(bulkupdateItemQuantitySaga),
        fork(plpDisclaimerContentSaga),
        fork(updateCustomerIDforOrderSaga),
        fork(generateClientTokenSaga),
        fork(transactionSaleSaga),
        fork(transactionSubmitSaga),
        fork(transactionVoidSaga),
        fork(updateCartWithStoreAndDispositionSaga),
        fork(fetchTokensSaga),
        fork(refreshTokenSaga),
        fork(logoutUserSaga),
        fork(fetchGoogleSpotTokensSaga),
        fork(protectedDisclosureSaga),
        fork(getStoreDetailsContentFullData),
        fork(nutritionAllergenDisclaimerSaga),
        fork(validateOrderSaga),
        fork(getContactUsRestaurantDetailsSaga),
        fork(getDeliveryLocationLocalizationData),
        fork(naSingleItemSaga),
        fork(getGuestContentSaga),
        fork(findAKFCContentSaga),
        fork(getDynMenuAlert),
        fork(globalPaymentsGenerateTokenSaga),
        fork(globalpaymentsInitiatePaymentSaga),
        fork(globalpaymentsAddressValidateSaga),
        fork(gpSavecardSaga),
        fork(gpIsStore3dsEnabledSaga),
        fork(gpCardVerifySaga),
    ]);
};
export default rootSaga;
//# sourceMappingURL=sagas.js.map
